import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducers from './reducers'
import firebase from 'firebase/app'
import 'firebase/auth'

const fbConfig = {
    apiKey: "AIzaSyD7KXo3Vq9rcHIvxVSqcOEFp1CAPAgfx3Y",
    authDomain: "react-gradient-69a81.firebaseapp.com",
    projectId: "react-gradient-69a81",
    storageBucket: "react-gradient-69a81.appspot.com",
    messagingSenderId: "957667913113",
    appId: "1:957667913113:web:984a896842cb10fc2c7708",
    measurementId: "G-657LJJMEQG"
}

firebase.initializeApp(fbConfig);

// react-redux-firebase config
const rrfConfig = {
  userProfile: "users",
  // useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
};

const store = createStore(rootReducers, composeWithDevTools(applyMiddleware(thunk)));

export  const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch
    // createFirestoreInstance // <- needed if using firestore
  }

export default store;